import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";

// Sticky bottom call-to-action bar shown on mobile for the 50-75 demographic.
const StickyMobileCTA = () => (
  <div
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-zinc-800 bg-black/95 backdrop-blur-xl"
    data-testid="sticky-mobile-cta"
  >
    <a
      href={PHONE_TEL}
      data-testid="sticky-call-button"
      className="flex items-center justify-center space-x-2 bg-[#C69453] text-black font-extrabold py-4 text-base"
    >
      <Phone className="w-5 h-5" />
      <span>Call Pryme</span>
    </a>
    <Link
      to="/contact"
      data-testid="sticky-estimate-button"
      data-track="cta_estimate"
      data-track-label="sticky-mobile"
      className="flex items-center justify-center space-x-2 bg-zinc-900 text-white font-bold py-4 text-base border-l border-zinc-800"
    >
      <FileText className="w-5 h-5 text-[#C69453]" />
      <span>Free Estimate</span>
    </Link>
  </div>
);

export default StickyMobileCTA;
